import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Button } from '@mui/material';

import PaginatedListWrapper from '../../../../../components/PagedFilterList';
import {
  selectIsLoadingWorkerContracts,
  selectWorkerContracts,
} from '../../../../../store/selectors/userListSelector';
import { BUTTON_STYLES } from '../../../../../theme/buttonStyles';
import { getWorkerContracts } from '../../../usersListReducer';

import ContractCard from './ContractCard';
import ContractTypeSelectModal from './ContractTypeSelectModal';
import NoContractCard from './NoContractCard';

const LIMIT = 5;

const WorkerContracts = ({ user }) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(selectIsLoadingWorkerContracts);
  const workerContracts = useSelector(selectWorkerContracts);

  const [page, setPage] = useState(0);
  const [isContractTypeModalOpen, setIsContractTypeModalOpen] = useState(false);

  // Reusable function to fetch worker contracts
  const fetchWorkerContracts = useCallback(() => {
    dispatch(
      getWorkerContracts({
        filters: [
          { field: 'contractScope.worker.id', operation: 'equalsID', value: user?.id },
          { field: 'state.status', operation: 'equals', value: 'active' },
        ],
        page,
        limit: LIMIT,
      })
    );
  }, [dispatch, user?.id, page]);

  useEffect(() => {
    fetchWorkerContracts();
  }, [fetchWorkerContracts]);

  const handleOnPageChange = (newPage) => {
    setPage(newPage);
  };

  const handleAddContractClick = () => {
    setIsContractTypeModalOpen(true);
  };

  const handleCloseContractTypeModal = () => {
    setIsContractTypeModalOpen(false);
  };

  const refreshContractData = () => {
    fetchWorkerContracts();
  };

  const title = LanguageConverterV2('userDetail.workerContracts.title');

  const content = (
    <Box display="flex" flexDirection="column" gap={2} width="100%">
      {workerContracts?.documents?.length > 0 ? (
        workerContracts?.documents?.map((contract) => (
          <ContractCard
            contract={contract}
            key={contract?._id}
            refreshContractData={refreshContractData}
          />
        ))
      ) : (
        <NoContractCard />
      )}
    </Box>
  );

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
        <Button
          variant="outlined"
          onClick={handleAddContractClick}
          sx={BUTTON_STYLES.primaryMedium}
        >
          {LanguageConverterV2('userDetail.workerContracts.addContractBtnText')}
        </Button>
      </Box>
      <PaginatedListWrapper
        isLoading={isLoading}
        content={content}
        limit={LIMIT}
        title={title}
        currentPageNum={page}
        totalListCount={workerContracts?.count}
        handleOnPageChange={handleOnPageChange}
      />
      <ContractTypeSelectModal
        isOpen={isContractTypeModalOpen}
        onClose={handleCloseContractTypeModal}
        userId={user?.id}
      />
    </Box>
  );
};
WorkerContracts.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
};
export default WorkerContracts;
